<template>
    <div>
        <div class="chart" id="conv" ref="chartRef" />
    </div>
</template>
  
<script>
import * as echarts from 'echarts/core';
import { GridComponent } from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([GridComponent, BarChart, CanvasRenderer]);


export default {

    components: {

    },
    props: {
        chartData: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            option: {},
            chartDom: null,
            myChart: null
        };
    },
    mounted() {
        this.chartDom = document.getElementById('conv');
        this.myChart = echarts.init(this.chartDom);

        this.option = {
            tooltip: {
                trigger: 'item',

            },

            series: [
                {
                    type: 'pie',
                    radius: ['60%', '70%'],
                    avoidLabelOverlap: false,


                    label: {
                        show: true,
                        position: 'center',
                        formatter: `Conversion Rate \n  \n \n ${this.chartData}%`,
                        fontWeight: 'bold',
                        fontSize: '20px',
                    },



                    color: [
                        '#9249EE',
                        '#E9E9E9'],
                    labelLine: {
                        show: false
                    },
                    data: [
                        this.chartData, 100 - this.chartData
                    ]
                },

            ]
        };
        this.myChart.on('click', (params) => {
         
            this.$emit('drilldown', { chart: 'ConversionRate', value: params.name })
        })
        this.option && this.myChart.setOption(this.option);
    }
};
</script>
  
<style scoped>
.chart {
    height: 100vh;
}
</style>
  
<style>
body {
    margin: 0;
}

#conv {
    height: 400px;
}
</style>